import React from 'react';
import './NotFound.css';

const NotFound = () => (
  <div className="NotFound">
    <h3>Tyvärr, sidan finns inte!</h3>
  </div>
);

export default NotFound;
